import { render } from "./icp.vue?vue&type=template&id=028f11a5&scoped=true&ts=true"
import script from "./icp.vue?vue&type=script&lang=ts"
export * from "./icp.vue?vue&type=script&lang=ts"

import "./icp.vue?vue&type=style&index=0&id=028f11a5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028f11a5"]])

export default __exports__